import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const AnimatedWrapper = styled.div`
    width: 100%;
    animation: ${slideDown} 0.35s ease-out forwards;
`;

export { AnimatedWrapper };
